import axios from 'axios';

export default () => axios.create({
  baseURL: 'https://api.upa.trixlog.com/api/',
  // baseURL: 'http://localhost:8080/api/',
  headers: {
    Authorization: localStorage.getItem('token') ? 'Basic ' + localStorage.getItem('token') : null
  }
});




// WEBPACK FOOTER //
// ./src/config/config-api.js